import React from "react";
import {
  ExtendedContentContainer,
  ExtendedContentType,
} from "components/ExtendedContent/ExtendedContentContainer";
import GroupInteractiveTool from "components/GroupInteractiveTool";
import { GroupInteractivetToolLoading } from "components/GroupInteractiveTool/Loading";

export const PaiNoteComponent = ({ canvasSVGObject }) => {
  
  return (
    <>
      <ExtendedContentContainer
        extendedContentType={ExtendedContentType.PaiNote}
      >
        <GroupInteractiveTool extendedContentType={ExtendedContentType.PaiNote} />
      </ExtendedContentContainer>
      <GroupInteractivetToolLoading />
    </>
  );
};
